module.exports = __webpack_public_path__ + "img/instruction_01.40267fcc.svg";